import CateringTaskReport from './cateringTaskReportContainer';
export default CateringTaskReport;
